import {categoryKeyToDisplayNameMap} from '../PricingTable/constants';
import {categoryFieldsConfig, FieldConfig} from './constants';

export const getCategoryKeyByDisplayName = (
  displayName: string
): string | undefined => {
  const entry = Object.entries(categoryKeyToDisplayNameMap).find(
    ([, value]) => value === displayName
  );
  return entry?.[0];
};

export const getFieldsByCategoryKey = (categoryName: string): FieldConfig[] => {
  const categoryKey = getCategoryKeyByDisplayName(categoryName);

  return categoryKey ? categoryFieldsConfig[categoryKey] || [] : [];
};
